<template>
  <div>
    <!-- 系统列表 -->
    <a-table id="myServiceTable" :columns="columns" :data-source="tableData"  :scroll="{ x: clientWidth}" :pagination="false"  :loading="tloading" rowKey="id"
    bordered size="middle" @change="handleTableChange">
        <template slot="rateText" slot-scope="text">
            <span >{{text + '%'}}</span>
        </template>
    </a-table>

    <a-pagination  style="float:right;margin-top:20px;" v-model="pagenation.current" :pageSize="pagenation.pageSize" :total="pagenation.total" @change="handlePageChange" show-less-items show-quick-jumper />

  </div>
</template>
<script>
let pagenation ={
    current:1,
    pageSize:10,
    total:0
};

const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagenation;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: "统计时间",
        dataIndex: "occurday",
        width:200,
        align: "center",

    },
    {
        title: "系统编码",
        dataIndex: "appcode",
        width:80,
        align: "center",

    },
    {
        title: "调用方系统编码",
        dataIndex: "invokeappcode",
        width:120,
        align: "center",

    },
    {
        title: "URL",
        dataIndex: "url",
        width:500,
        align: "left",
        ellipsis: true
    },
    {
        title: "调用方式",
        dataIndex: "type",
        width:80,
        align: "center",
    },
    {
        title:"消费方指标",
        children:[
            {
                title: "调用次数",
                dataIndex: "total",
                width:90,
                sorter: true,
                defaultSortOrder :'descend',
                align: "center",
            },
            {
                title: '调用成功',
                children:[
                    {
                        title: '成功次数',
                        dataIndex: 'successnum',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    },
    
                    {
                        title: '成功比例',
                        dataIndex: 'successrate',
                        align: 'center',
                        scopedSlots: { customRender: 'rateText' },
                        width: 90,
                    },
   
                ]
            },
            {
                title: '调用失败',
                children:[
                    {
                        title: '失败次数',
                        dataIndex: 'failnum',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    },
                    {
                        title: '失败比例',
                        dataIndex: 'failrate',
                        align: 'center',
                        width: 90,
                        scopedSlots: { customRender: 'rateText' },
                    },
                ]
            },{
                title: '调用耗时',
                children:[
                    
                    {
                        title: '平均耗时',
                        dataIndex: 'avghandtime',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    },
                    {
                        title: 'TP90',
                        dataIndex: 'tp90',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    },
                    {
                        title: 'TP99',
                        dataIndex: 'tp99',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    },
                    {
                        title: 'TP999',
                        dataIndex: 'tp999',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    }
                ]
            },
        ]
    },
];




export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagenation,
            clientWidth:800,
            visible:false,
            ordercoloum:'total',
            orderstr:'desc'
        };
    },
    methods: {
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.ordercoloum = sorter.field ;
                this.orderstr = sorter.order.replace('end','');
            }
            else{
                this.ordercoloum = '';
                this.orderstr = '';
            }

            this.getAppSumData();
        },
        handlePageChange(v){
            this.pagenation.current = v
            this.getAppSumData();
        },
        getAppSumData(){
            let that = this
            this.columns[1].dataIndex =  that.searchD.timeType == 'perDay' ? 'occurday' : 'occurtime';
            let startDate = that.searchD.searchTimeRange.split('~')[0];
            let endDate = that.searchD.searchTimeRange.split('~')[1];

            let urlPath = that.searchD.timeType == 'perDay' ? 'getservicehistoryday' : 'getservicehistoryhour';
            let params = {
                startDate,
                endDate,
                selectedAppcode:that.searchD.selectedAppcode,
                selectedInvokeappcode:that.searchD.selectedInvokeappcode,
                servicekey:that.searchD.servicekey,
                ordercoloum: that.ordercoloum,
                orderstr: that.orderstr,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/"+ urlPath,
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.tableData = res.data.data.list;
                    that.pagenation.total = res.data.data.totalRecords;
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
    },
    props:{
        searchD:{
            selectedAppcode:String,
            selectedInvokeappcode:String,
            servicekey:String,
            searchTimeRange:String,
            timeType:String,
        }

    },
    watch:{
        'searchD'(newVal){
            if(newVal){
                this.pagenation.current = 1;
                this.getAppSumData();
            }
        }
    },
    components:{
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagenation{
        margin-top: 10px;
    }


</style>

